import { z } from 'zod';
// import { Interval, intervalSchema } from 'app/agriculture/queries/types/Interval';
import { MapLocation, mapLocationSchema } from 'app/agriculture/queries/types/MapLocation';
import { TaskPriority, taskPrioritySchema } from 'app/agriculture/queries/tasks/types/TaskPriority';
import { sub as subDuration } from 'date-fns';

export interface Task {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    title: string;
    category: string;
    description: string | null;
    location: MapLocation | null;
    isComplete: boolean;
    priority: TaskPriority;

    // interval: Interval;
    startDate: Date;
    endDate: Date;

    parentIds: string[];
    assignees: number[];
}

export const taskSchema = z.object({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    title: z.string(),
    category: z.string(),
    description: z.string().nullable(),
    location: mapLocationSchema.nullable(),
    isComplete: z.boolean(),
    priority: taskPrioritySchema,

    // interval: intervalSchema,
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),

    parentIds: z.array(z.string().uuid()),
    assignees: z.array(z.number()),
});

export const mockTask = ({
    id = 'a851da9e-3f01-4b4a-a7e7-5b870a5f1714',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    title = 'Mock Task Title',
    category = 'Mock Task Category',
    description = 'Mock Task Description',
    location = { latitude: 0, longitude: 0 },
    isComplete = false,
    priority = 'Normal',

    // interval = {
    //     start: subDuration(new Date(), { days: 1 }),
    //     end: new Date()
    // },
    startDate = subDuration(new Date(), { days: 1 }),
    endDate = new Date(),

    parentIds = ['ad998c0a-020c-4eaf-a858-48e721cc88d9'],
    assignees = [1],
}: Partial<Task> = {}): Task => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    title,
    category,
    description,
    location,
    isComplete,
    priority,

    // interval,
    startDate,
    endDate,

    parentIds,
    assignees,
});
